import React, { forwardRef, useMemo } from 'react'
import type { SelectProps } from 'antd'
import { Button, Divider, Flex, Select, Spin, Typography } from 'antd'
import CSS from 'csstype'
import { useTranslation } from 'react-i18next'

const { Text } = Typography

export type CustomSelectProps = SelectProps & {
  title: string
  onApply?: () => void
  applyButtonLabel?: string
  parentContainerFlex?: string | number
}

const selectFooterStyles: CSS.Properties = {
  padding: '0.1em',
}

const GenericSelect = forwardRef<any, CustomSelectProps>(
  (
    { title, onApply, onChange, options, applyButtonLabel, onSearch, placeholder, parentContainerFlex, ...restProps },
    ref,
  ) => {
    const { t } = useTranslation('labels')
    const [fetching, setFetching] = React.useState<boolean>(false)

    const debounceFetch = useMemo(
      () => (value: string) => {
        setFetching(true)
        if (onSearch) {
          onSearch(value)
        }
        setFetching(false)
      },
      [onSearch],
    )

    return (
      <Flex vertical flex={parentContainerFlex}>
        <Text>{title}</Text>
        <Select
          ref={ref}
          notFoundContent={fetching ? <Spin size="small" /> : t('valueNotFound')}
          size="large"
          onChange={onChange}
          placeholder={placeholder}
          options={options}
          popupRender={(menu) => (
            <>
              {menu}
              {onApply && applyButtonLabel && (
                <>
                  <Divider size="small" />
                  <Flex justify="flex-end" style={selectFooterStyles}>
                    <Button type="primary" onClick={onApply}>
                      {applyButtonLabel}
                    </Button>
                  </Flex>
                </>
              )}
            </>
          )}
          onSearch={debounceFetch}
          {...restProps}
        />
      </Flex>
    )
  },
)

export default GenericSelect
